export default __webpack_public_path__ + "media/images/deroulant-8ecaf6432d6b6f04d667f5bc1afadb42.png";